export default __webpack_public_path__ + "static/Energy_Brew-65b40ca97c329c9911384834a9c89c4c.png";